import useEmailAllowlist from "./useEmailAllowlist";

// Gates /coin-logs. Deliberately NOT the same set as SUPER_ADMIN_EMAILS in
// useSuperAdmin — james.dickins@ has coin-logs access without super-admin.
const COIN_LOGS_EMAILS = [
  "flo@gamelight.io",
  "gunay@gamelight.io",
  "james.dickins@gamelight.io",
];

export default function useCoinLogsAccess() {
  return useEmailAllowlist(COIN_LOGS_EMAILS);
}
